import { memo } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
// Import Components
import BonusModal from 'components/BonusModal';

const BonusActionsModals = (props) => {
    const { isInfoModalOpenedState, onCloseModalHandler, modalsStateSetDict, openedModalData } = props;

    const Id = openedModalData?.Id;

    return isEmpty(openedModalData) ? null : (
        <>
            {isInfoModalOpenedState && (
                <BonusModal
                    bonusId={Id}
                    handleClose={() => onCloseModalHandler(modalsStateSetDict.infoBonus.key)}
                    isVisible={isInfoModalOpenedState}
                />
            )}
        </>
    );
};

BonusActionsModals.propTypes = {
    isInfoModalOpenedState: PropTypes.bool.isRequired,
    onCloseModalHandler: PropTypes.func.isRequired,
    modalsStateSetDict: PropTypes.object.isRequired,
    openedModalData: PropTypes.object,
};

export default memo(BonusActionsModals);
